import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../_services/api.service';
declare var $: any;
import { MatSnackBar } from '@angular/material/snack-bar';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from 'src/_services/translate.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe, Location } from '@angular/common';

@Component({
  selector: 'app-employee-termination',
  templateUrl: './employee-termination.component.html',
  styleUrls: ['./employee-termination.component.scss']
})
export class EmployeeTerminationComponent implements OnInit {
  employeesallList: any[] = [];
  searchList: any[] = [];
  employeeDetail: any;
  startat: Date;
  todayDate: Date = new Date();
  id: any;
  employeeBeforeSubmit: boolean;
  resubmit: boolean;
  employeeWithCcpsStage1: boolean;
  response: any;
  countryList: any;
  public CcpsStage1Form: FormGroup;
  public resignationForm: FormGroup;
  resign_reason: any[] = [];
  resign_reason_document: string | null = null;
  responseupload: any;
  responseresign: any;
  resignReason: any;
  rsubmitted = false;

  filteredEmployees: any[] = [];
  searchTerm = '';
  hasSearched = false;

  constructor(private api: ApiService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private ngxUiLoaderService: NgxUiLoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private location: Location,
  ) {
    this.todayDate.setHours(23, 59, 59, 999);
  }

  ngOnInit() {
    this.resignationForm = this.formBuilder.group({
      date_of_resignation: ['', [Validators.required]],
      reason: ['', [Validators.required]],
      reason_type: [''],
      resign_reason_document: [''],
    });
    this.getResignReasonList();
    this.loadEmployees();
  }
  loadEmployees() {
    this.api.getEmployeeList({ entity_type: '7' }).subscribe((res: any) => {
      if (res && res.status === 200 && res.result && res.result.results) {
        this.employeesallList = res.result.results;
        this.searchList = this.employeesallList;
        this.filteredEmployees = this.employeesallList;
        this.hasSearched = true; // Show the table when employees are loaded
      } else {
        this.snackBar.open(res.message, "OK", {
          duration: 5000,
        });
      }
    });
  }


  filterEmployees(searchValue: string) {
    this.searchTerm = searchValue || '';
    const normalizedTerm = this.searchTerm.trim().toLowerCase();

    // If search is empty, show all employees
    if (!normalizedTerm) {
      this.filteredEmployees = this.employeesallList;
      return;
    }

    // Filter employees based on search term (search in multiple fields)
    this.filteredEmployees = this.employeesallList.filter((employee: any) => {
      const name = (employee.name || '').toLowerCase();
      const ccpsCode = (employee.ccps_code || '').toLowerCase();
      const nipNumber = (employee.nip_number || '').toLowerCase();
      const designation = (employee.designation || '').toLowerCase();
      const cnamgs = (employee.cnamgs || '').toLowerCase();
      const cnss = (employee.cnss || '').toLowerCase();
      const mobile = (employee.mobile || '').toLowerCase();

      return name.includes(normalizedTerm) ||
        ccpsCode.includes(normalizedTerm) ||
        nipNumber.includes(normalizedTerm) ||
        designation.includes(normalizedTerm) ||
        cnamgs.includes(normalizedTerm) ||
        cnss.includes(normalizedTerm) ||
        mobile.includes(normalizedTerm);
    });
  }


  get a() {
    return this.resignationForm.controls;
  }

  getResignReasonList() {
    this.ngxUiLoaderService.start();
    this.api.getResignReasonLists().pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        if (res.status == 200) {
          this.resign_reason = res.results;
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
        });
  }

  setValidator(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.a['resign_reason_document'].setValue('');
    this.resign_reason_document = null;
    this.resignReason = value;
    if (value === '14') {
      this.a['reason_type'].setValidators([Validators.required]);
    } else {
      this.a['reason_type'].clearValidators();
    }
    if (value === '3' || value === '4' || value === '13') {
      this.a['resign_reason_document'].setValidators([Validators.required]);
    } else {
      this.a['resign_reason_document'].clearValidators();
    }
    this.a['reason_type'].updateValueAndValidity();
    this.a['resign_reason_document'].updateValueAndValidity();
  }




  // get noDataMessage() {
  //   if (!this.hasSearched) {
  //     return 'Start typing to search for employees.';
  //   }
  //   const trimmedTerm = this.searchTerm.trim();
  //   if (trimmedTerm) {
  //     return `No employees match "${trimmedTerm}".`;
  //   }
  //   return 'No employee records are currently available.';
  // }
  get noDataMessage(): string {
    // If employees are loaded but filtered list is empty, show no match message
    if (this.hasSearched && this.employeesallList.length > 0) {
      const trimmedTerm = this.searchTerm.trim();
      if (trimmedTerm) {
        let message = this.translate.data['NO_EMPLOYEES_MATCH'] || 'NO_EMPLOYEES_MATCH';
        return message.replace('{{term}}', trimmedTerm);
      }
    }
    // If no employees are loaded at all
    if (!this.hasSearched || this.employeesallList.length === 0) {
      return this.translate.data['NO_EMPLOYEE_RECORDS'] || 'NO_EMPLOYEE_RECORDS';
    }
    return this.translate.data['NO_EMPLOYEE_RECORDS'] || 'NO_EMPLOYEE_RECORDS';
  }


  upload(event: Event, _id: string) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) {
      return;
    }
    const file = input.files[0];
    const filename = file.name;
    const segments = filename.split('.');
    const ext = segments.length ? segments[segments.length - 1].toLowerCase() : '';
    const allowedExt = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'bmp', 'webp', 'tiff'];
    if (!ext || !allowedExt.includes(ext)) {
      alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .doc .docx .bmp .webp .tiff');
      return;
    }
    if (file.size > 5242880) {
      alert('File size should be less than 5MB');
      return;
    }
    const formData = new FormData();
    const target = input.dataset.target || 'resign_reason_document';
    formData.append('image', file);
    formData.append('target', target);
    formData['encrypt_mode'] = false;
    this.ngxUiLoaderService.start();
    this.api.upload(formData).pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.responseupload = res;
        if (res.status == 200) {
          this.resignationForm.get('resign_reason_document').setValue(this.responseupload.results.file);
          this.resign_reason_document = this.responseupload.results.imageUrl;
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        } else {
          this.snackBar.open(res.message, "OK", {
            duration: 5000,
          });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  resignationModalOpen() {
    this.rsubmitted = true;
    if (this.resignationForm.invalid) {
      console.log(this.resignationForm)
      return;
    } else {
      $('#employeeResignModal').modal('hide');
      $('#resignation-confirm-modal').modal('show');
    }
  }

  convertOwl(str) {
    if (str == null)
      return str;
    const mnths = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12"
    };
    const date = str.toString().split(" ");
    if (date.length == 1)
      return str;
    else
      return [date[2], mnths[date[1]], date[3]].join("-");
  }

  setFilteredEmployees(e: any) {
    console.log(e);
    this.employeesallList = this.searchList.filter((employeeList: any) => {
      const designation = employeeList.designation || '';
      const mobile = employeeList.mobile || '';
      const name = employeeList.name || '';
      const cnss = employeeList.cnss || '';
      const ccps_code = employeeList.ccps_code || '';

      return (
        designation.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        mobile.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        cnss.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1 ||
        ccps_code.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
      );
    });
    // this.getDisplayedData();
  }


  resignEmployee(employee) {
    this.employeeDetail = employee;
    // const joinDate = this.employeeDetail.join_date ? new Date(this.employeeDetail.join_date) : null;
    // this.startat = joinDate;
    // this.startat.setHours(0, 0, 0, 0);

    if (this.employeeDetail.join_date) {
      this.startat = new Date(this.employeeDetail.join_date);
      this.startat.setHours(0, 0, 0, 0);
    } else {
      this.startat = null;
    }
    console.log("1369startat", this.startat)
    $('#employeeResignModal').modal('show');
  }

  closeModal() {
    $('#employeeResignModal').modal('hide');
    this.resignationForm.reset();
    this.resignReason = null;
    this.resign_reason_document = null;
    this.rsubmitted = false;
    this.a['reason_type'].clearValidators();
    this.a['reason_type'].updateValueAndValidity();
    this.a['resign_reason_document'].clearValidators();
    this.a['resign_reason_document'].updateValueAndValidity();
  }

  onSubmitResign() {
    this.rsubmitted = true;

    if (this.resignationForm.invalid) {
      return;
    }


    var data = this.resignationForm.value;
    data['employee_id'] = this.employeeDetail.id;
    data['date_of_resignation'] = this.convertOwl(data.date_of_resignation)


    console.log("workingggggggggggggggggggggggggggggg", data)
    this.ngxUiLoaderService.start();

    this.api.resignEmployee(data).pipe(first())
      .subscribe(data => {
        this.rsubmitted = false;
        this.ngxUiLoaderService.stop();
        this.responseresign = data;
        if (this.responseresign.status == 200) {
          $('#employeeResignModal').modal('hide');
          $('#resignation-confirm-modal').modal('hide');
          this.resignationForm.reset();

          this.resign_reason_document = null;
          this.resignReason = null;
          this.loadEmployees();
          // this.router.navigate(['/employees']);

        } else {
        }
        this.snackBar.open(this.responseresign.message, "OK", {
          duration: 5000,
        });
      },
        error => {
          this.rsubmitted = false;
          this.ngxUiLoaderService.stop();
          this.snackBar.open(error && error.message ? error.message : 'Error submitting resignation', "OK", {
            duration: 5000,
          });
        });
  }
  goback() {
    if (this.CcpsStage1Form) {
      this.CcpsStage1Form.reset();
    }
    // this.location.back();
    this.router.navigate(['/employees']);
  }
}
